/*
Copyright (c) 2021
*/

import constants from '../../constants';

const {
  REQUEST_SUMMARYDATA,
  SUMMARYDATA_RECEIVED,
  EDIT_SUMMARYDATA,
  CLEAR_SUMMARYDATA
} = constants.summaryDataConstants;
// const { REQUEST_SUMMARYDATA,SUMMARYDATA_RECEIVED } = constants.summaryDataConstants;

export default {
  REQUEST_SUMMARYDATA,
  SUMMARYDATA_RECEIVED,
  EDIT_SUMMARYDATA,
  CLEAR_SUMMARYDATA,

  requestSummaryData: payload => ({
    type: REQUEST_SUMMARYDATA,
    payload
  }),
  summaryDataReceived: () => ({
    type: SUMMARYDATA_RECEIVED
  }),

  editSummaryData: payload => ({
    type: EDIT_SUMMARYDATA,
    payload
  }),

  clearSummaryData: payload => ({
    type: CLEAR_SUMMARYDATA
  })
};
